export default "__VITE_ASSET__FQmSlCyz__"